import {disableTextSelection} from '../atBrowserUtils'
import SelectionController from "./SelectionController";
import HoverController from "./HoverController";
import TableMouseEventsHandler from "./TableMouseEventsHandler";
import TableRegion from "./TableRegion";
import TemplateView from '../TemplateView'

export default class Table extends TemplateView {
    constructor(tHeadEl, containerEl) {
        super(containerEl)

        this.containerEl = containerEl;
        this.rows = [];
        this.tableEl = document.createElement("table");
        this.tableEl.cellPadding = 0;
        this.tableEl.cellSpacing = 0;
        this.tableEl.border = 0;
        this.tbody = document.createElement("tBody");

        // TODO: too much stuff happening in the constructor

        if (tHeadEl)
            this.tableEl.appendChild(tHeadEl);
        this.tableEl.appendChild(this.tbody);

        //noinspection SpellCheckingInspection
        var thisDeref = this;

        this.selectionController = this.createSelectionController();
        if (this.selectionController != null)
            this.selectionController.addSelectionChangeListener(function(selectionChangeEvent, mouseEvent) {
                thisDeref.selectionChanged(selectionChangeEvent, mouseEvent);
            });

        this.hoverController = this.createHoverController();
        if (this.hoverController != null)
            this.hoverController.addHoverChangeListener(function(hoverChangeEvent, mouseEvent) {
                thisDeref.hoverChanged(hoverChangeEvent, mouseEvent);
            });

        this.mouseEventsHandler = this.createMouseEventsHandler();
    }

    // abstract
    createSelectionController()
    {
        return new SelectionController();
    }

    // abstract
    createHoverController()
    {
        return new HoverController();
    }

    // abstract
    createMouseEventsHandler()
    {
        return new TableMouseEventsHandler(this, this.getSelectionController(), this.getHoverController());
    }

    getTBody()
    {
        return this.tbody;
    }

    getSelectionController()
    {
        return this.selectionController;
    }

    getHoverController()
    {
        return this.hoverController;
    }

    getMouseEventsHandler()
    {
        return this.mouseEventsHandler;
    }

    setupRow(rowIdx, row)
    {
        row.setRowIdx(rowIdx);
        row.setTable(this);
    }

    addRow(row)
    {
        this.setupRow(this.rows.length, row)
        this.rows.push(row);
    }

    replaceRowAndUpdateDOM(rowIdx, newRow, updateRowBelow)
    {
        var oldRow = this.rows[rowIdx]

        this.setupRow(rowIdx, newRow)
        this.rows[rowIdx] = newRow

        var tmpTableEl = document.createElement("table")
        var tmpTBodyEl = document.createElement("tbody")
        tmpTableEl.appendChild(tmpTBodyEl);

        newRow.buildDOM(tmpTBodyEl)
        newRow.writeCellsContent()
        newRow.getRowEl().className = this.getRowElClasses(rowIdx).join(" ")

        oldRow.getRowEl().parentNode.replaceChild(newRow.getRowEl(), oldRow.getRowEl())

        if (updateRowBelow)
        {
            var belowIdx = rowIdx + 1;
            if (belowIdx <= this.getLastRow().getRowIdx())
            {
                var belowRow = this.getRow(belowIdx)
                this.updateCellRegionUI(new TableRegion(belowIdx, 0, belowIdx, belowRow.getCells().length - 1))
            }
        }
    }

    getRows(row)
    {
        return this.rows
    }

    getRow(rowIdx)
    {
        return this.rows[rowIdx]
    }

    getLastRow()
    {
        return this.rows[this.rows.length - 1]
    }

    getFirstRow()
    {
        return this.rows[0]
    }

    getCell(rowIdx, colIdx)
    {
        return this.rows[rowIdx].getCell(colIdx)
    }

    updateCell(cell)
    {
        cell.updateCell()
    }

    buildModelRowsDOM(containerEl)
    {
        var aRow = null
        for (var i = 0; i < this.rows.length; i++)
        {
            aRow = this.rows[i]
            aRow.buildDOM(containerEl)
            aRow.writeCellsContent()
            aRow.getRowEl().className = this.getRowElClasses(i).join(" ")
        }
    }

    deleteAllRowsFromModelAndDom()
    {
        for (var i = 0; i < this.rows.length; i++)
            this.tbody.removeChild(this.rows[i].getRowEl())
        this.rows = []
    }

    removeRow(rowIdx)
    {
        var row = this.rows[rowIdx]
        this.tbody.removeChild(row.getRowEl())
        this.rows.splice(rowIdx, 1)
        for (var i = rowIdx; i < this.rows.length; i++)
            this.setupRow(i, this.rows[i])
    }


    getTableEl()
    {
        return this.tableEl
    }

    buildDOM(containerEl)
    {
        this.buildModelRowsDOM(this.tbody)

        this.disableTextSelection()

        containerEl.appendChild(this.tableEl)
    }

    disableTextSelection()
    {
        disableTextSelection(this.tableEl)
    }

    getBaseRowClasses(rowIdx)
    {
        return []
    }

    getRowElClasses(rowIdx)
    {
        var rowClasses = this.getBaseRowClasses(rowIdx)
        this.appendSelectedRowClassIfNecessary(rowIdx, rowClasses)
        return rowClasses
    }

    appendSelectedRowClassIfNecessary(rowIdx, rowClasses)
    {
        if (this.getSelectionController().getSelection().containsRow(rowIdx))
            rowClasses.push("hasSelection")
    }

    updateCellRegionUI(region)
    {
        // update region
        var row = null
        for (var rowIdx = region.rowMin; rowIdx <= region.rowMax; rowIdx++)
        {
            row = this.rows[rowIdx]
            row.getRowEl().className = this.getRowElClasses(rowIdx).join(" ")
            for (var colIdx = region.colMin; colIdx <= region.colMax; colIdx++)
                row.updateCellUI(colIdx)
        }
    }

    computeChangedRegion(regionChangeEvent)
    {
        return regionChangeEvent.oldValue.union(regionChangeEvent.newValue)
    }

    selectionChanged(selectionChangeEvent)
    {
        var updateRegion = this.computeChangedRegion(selectionChangeEvent)
        this.updateSelectionChangeRegionUI(updateRegion)
    }

    updateSelectionChangeRegionUI(updateRegion)
    {
        this.updateCellRegionUI(
            // +1 col and +1 row to update right and bottom borders of the selection region
            new TableRegion(
                updateRegion.rowMin,
                updateRegion.colMin,
                Math.min(updateRegion.rowMax + 1, this.getLastRow().getRowIdx()),
                Math.min(updateRegion.colMax + 1, this.getRow(updateRegion.rowMax).getCells().length - 1)
            )
        )
    }

    hoverChanged(hoverChangeEvent)
    {
        var updateRegion = this.computeChangedRegion(hoverChangeEvent)
        if (updateRegion != null)
            this.updateCellRegionUI(updateRegion)
    }

    clearSelection()
    {
        this.getSelectionController().clearSelection()
    }

    clearHover()
    {
        this.getHoverController().unhover()
    }
}



// WEBPACK FOOTER //
// ./web/js/table/Table.js